export const initialCoursewareLoadingState: boolean = true;
